"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getAssetDisplayText = getAssetDisplayText;
exports.getAssetSymbolAndName = getAssetSymbolAndName;
exports.venueAssetSymbol = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _ObjectUtils = require("./ObjectUtils");
var _LangUtils = require("./LangUtils");
var _AssetType = _interopRequireDefault(require("../enums/AssetType"));
function getAssetDisplayText(asset) {
  var dflt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return [_AssetType.default.CRYPTO, _AssetType.default.FIAT].includes((0, _ObjectUtils.get)(asset, 'type')) ? (0, _ObjectUtils.get)(asset, 'symbol') || dflt : (0, _ObjectUtils.get)(asset, 'name') || dflt;
}
function getAssetSymbolAndName(asset) {
  var nameInParen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var symbol = (0, _ObjectUtils.get)(asset, 'symbol') || '';
  var name = (0, _ObjectUtils.get)(asset, 'name') || '';
  var _ref = nameInParen ? [symbol, name] : [name, symbol],
    _ref2 = (0, _slicedToArray2.default)(_ref, 2),
    str1 = _ref2[0],
    str2 = _ref2[1];
  return `${str1}${!(0, _LangUtils.isEmpty)(str2) ? ` (${str2})` : ''}`;
}
var venueAssetSymbol = function venueAssetSymbol() {
  var asset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return asset.alternateSymbol || asset.symbol;
};
exports.venueAssetSymbol = venueAssetSymbol;
var _default = {
  getAssetDisplayText,
  getAssetSymbolAndName,
  venueAssetSymbol
};
exports.default = _default;